import { RadialBarChart, RadialBar, PolarAngleAxis, ResponsiveContainer } from "recharts";
import { CircleNotch } from "@phosphor-icons/react";

export function Card({ children, className = "", testid }) {
  return (
    <div data-testid={testid} className={`bg-card border border-border p-6 transition-[transform,border-color] duration-300 ease-out hover:border-white/20 ${className}`}>
      {children}
    </div>
  );
}

export function Overline({ children, className = "" }) {
  return <div className={`overline text-muted-foreground ${className}`}>{children}</div>;
}

export function Metric({ label, value, sub, testid }) {
  return (
    <Card testid={testid}>
      <Overline>{label}</Overline>
      <div className="font-mono text-3xl font-bold mt-2 tracking-tight" data-testid={testid ? `${testid}-value` : undefined}>
        {value}
      </div>
      {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
    </Card>
  );
}

export function Spinner({ label = "Working…" }) {
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground font-mono">
      <CircleNotch size={18} className="animate-spin" />
      {label}
    </div>
  );
}

export function Empty({ children }) {
  return (
    <div className="border border-dashed border-border p-10 text-center text-sm text-muted-foreground">
      {children}
    </div>
  );
}

export function scoreColor(score) {
  if (score >= 75) return "#E9AC0C";
  if (score >= 50) return "#13C4E8";
  if (score >= 30) return "#9D3FFF";
  return "#DC2450";
}

export function Gauge({ score, size = 200 }) {
  const color = scoreColor(score);
  const data = [{ value: score, fill: "url(#gaugeGrad)" }];
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="reputation-gauge">
      <ResponsiveContainer width="100%" height="100%">
        <RadialBarChart innerRadius="72%" outerRadius="100%" data={data} startAngle={220} endAngle={-40}>
          <defs>
            <linearGradient id="gaugeGrad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#9D3FFF" />
              <stop offset="55%" stopColor="#13C4E8" />
              <stop offset="100%" stopColor="#E9AC0C" />
            </linearGradient>
          </defs>
          <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
          <RadialBar background={{ fill: "#161616" }} dataKey="value" cornerRadius={2} />
        </RadialBarChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-head text-6xl font-bold tracking-tighter" style={{ color, textShadow: `0 0 24px ${color}55` }}>
          {score}
        </div>
        <Overline className="mt-1">REP SCORE</Overline>
      </div>
    </div>
  );
}

export function Pill({ tone = "neutral", children }) {
  const map = {
    positive: "text-emerald-400 border-emerald-400/30 bg-emerald-400/10",
    negative: "text-destructive border-destructive/30 bg-destructive/10",
    neutral: "text-muted-foreground border-border bg-secondary",
    high: "text-destructive border-destructive/30 bg-destructive/10",
    medium: "text-yellow-400 border-yellow-400/30 bg-yellow-400/10",
    low: "text-emerald-400 border-emerald-400/30 bg-emerald-400/10",
  };
  return (
    <span className={`inline-block text-[0.65rem] font-mono uppercase tracking-wider px-2 py-0.5 border ${map[tone] || map.neutral}`}>
      {children}
    </span>
  );
}
